import {HttpErrorResponse} from '@angular/common/http';
import {BrowserAuthError, BrowserAuthErrorCodes, InteractionRequiredAuthError} from '@azure/msal-browser';

export type ShellLoadFailureKind =
    | 'auth-required'
    | 'access-denied'
    | 'load-failed'
    | 'no-client-access'
    | 'account-selection-required';

const readStatus = (error: unknown): number | null => {
    if (error instanceof HttpErrorResponse) {
        return typeof error.status === 'number' ? error.status : null;
    }

    if (error && typeof error === 'object' && typeof (error as {status?: unknown}).status === 'number') {
        return (error as {status: number}).status;
    }

    return null;
};

export const classifyShellLoadFailure = (error: unknown): ShellLoadFailureKind => {
    if (error instanceof InteractionRequiredAuthError) {
        return 'auth-required';
    }

    if (error instanceof BrowserAuthError && error.errorCode === BrowserAuthErrorCodes.timedOut) {
        return 'auth-required';
    }

    if (error instanceof Error && error.message === 'No active MSAL account found') {
        return 'auth-required';
    }

    const status = readStatus(error);
    if (status === 401) {
        return 'auth-required';
    }

    if (status === 403) {
        return 'access-denied';
    }

    return 'load-failed';
};
